module.exports = __webpack_public_path__ + "static/media/visa-blue.797e636f.svg";